$('.m-ilink--search').on('click', (e) => {
  e.preventDefault();

  $('.m-search-overlay').addClass('m-search-overlay--open');

  setTimeout(
    function () {
      $('.tx-solr-q').focus();
    },
    500
  );
});

$('.m-search-overlay__logo-close').on('click', (e) => {
  e.preventDefault();
  $(this).removeClass('active');
  $('.m-search-overlay').removeClass('m-search-overlay--open');
});


var $eplanQuickSearchDebounce = null;
var $eplanQuickSearch = $('#eplan-search-quick');
var $eplanQuickSearchInput = $($eplanQuickSearch).find('.eplan-search-q');
var $eplanQuickSearchResults = $('#eplan-search-quick-results');
var $eplanQuickSearchResultsTitle = $($eplanQuickSearch).data('suggest-header');

var eplanQuickSearchUpdate = function () {
  var q = $($eplanQuickSearchInput).val();
  var url = $($eplanQuickSearch).data('suggest');
  $.ajax({ url, data: { tx_searchfrontend_eplansearchautocomplete: { query: q } }, type: 'GET' })
    .done(function (results) {
      eplanQuickSearch(results);
    });
}

var eplanQuickSearch = function (results) {
  $eplanQuickSearchResults.html('');

  $.each(results.suggestions, function (index, value) {
    $eplanQuickSearchResults.append(`<li class="suggestion">${value}</li>`)
  });

  $eplanQuickSearchResults.find('li.suggestion').click(function (e) {
    $eplanQuickSearchInput.val($(this).text());
    eplanQuickSearchUpdate();
  });

  if (results.pages.length > 0) {
    $eplanQuickSearchResults.append(`<li class="suggestion-title">${$eplanQuickSearchResultsTitle}</li>`);

    $.each(results.pages, function (index, value) {
      $eplanQuickSearchResults.append(`<li><a href="${value.url}">${value.name}</a></li>`);
    });
  }
}


$eplanQuickSearchInput.on('keyup', function () {
  clearTimeout($eplanQuickSearchDebounce);
  $eplanQuickSearchDebounce = setTimeout(function () {
    eplanQuickSearchUpdate();
  }, 250);
});
